import FormLegalName from "@components/inputs/FormLegalName";
import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants/onboarding-steps";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { closeOnboardingDialog } from "@components/utils/OnboardingDialog/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface LegalNameStepProps extends OnboardingStepProps {
  onUpdateSuccess?: () => void;
  step?: OnboardingDialogStep;
}

const LegalNameStep = ({ handleClose, onUpdateSuccess, layout, step }: LegalNameStepProps) => {
  const { t } = useTranslation();

  const handleOnUpdateSuccess = useCallback(() => {
    closeOnboardingDialog();
    onUpdateSuccess?.();
  }, [onUpdateSuccess]);

  return (
    <OnboardingDialogLayout
      layout={layout}
      pageTitle={t("register")}
      pageSubTitle={" "}
      navigation={{
        close: {
          onClick: handleClose,
        },
      }}
      features={{
        showCloseButton: true,
      }}
    >
      <FormLegalName
        onUpdateSuccess={handleOnUpdateSuccess}
        mode={step === OnboardingDialogStep.UpdateLegalName ? "update" : "add"}
      />
    </OnboardingDialogLayout>
  );
};

export default LegalNameStep;
